import React from 'react';
import CarouselComponent from '../CarousalComponent';
import { CarouselWrapper, CloseButton, Overlay } from './styles';

interface ICarouselModalProps {
  onClose: () => void;
}

const CarouselModal: React.FC<ICarouselModalProps> = ({ onClose }) => {
  return (
    <>
      <Overlay />
      <CarouselWrapper>
        <CloseButton onClick={onClose} />
        <CarouselComponent />
      </CarouselWrapper>
    </>
  );
};

export default CarouselModal;
